import { IApplicationState } from '../../types/redux';

export const selectProductById = (id: string) => (state: IApplicationState) => {
  return state.analytics.productsById[id];
};
